"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../utils/index");

var _checkmark_icon_component = _interopRequireDefault(require("./checkmark_icon_component"));

var _selection_item_data_component = _interopRequireDefault(require("./selection_item_data_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * 这里需要用类组件，不能用函数组件，因为函数组件不能给予refs，与 popover 搭配使用会报 warnings
 */
var SelectionLabelsItemComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SelectionLabelsItemComponent, _React$PureComponent);

  function SelectionLabelsItemComponent() {
    _classCallCheck(this, SelectionLabelsItemComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelectionLabelsItemComponent).apply(this, arguments));
  }

  _createClass(SelectionLabelsItemComponent, [{
    key: "getItemDataComponent",
    // 获取选项组件
    value: function getItemDataComponent() {
      var propsSelectionItemDataComponent = this.props.SelectionItemDataComponent;
      var result = null;

      if (typeof propsSelectionItemDataComponent !== 'undefined' && propsSelectionItemDataComponent) {
        result = propsSelectionItemDataComponent;
      } else {
        result = _selection_item_data_component["default"];
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$open = _this$props.open,
          open = _this$props$open === void 0 ? false : _this$props$open,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? {} : _this$props$data,
          multiple = _this$props.multiple,
          _this$props$useCheckM = _this$props.useCheckMark,
          useCheckMark = _this$props$useCheckM === void 0 ? false : _this$props$useCheckM,
          _this$props$changeTri = _this$props.changeTriggerEvent,
          changeTriggerEvent = _this$props$changeTri === void 0 ? 'onClick' : _this$props$changeTri,
          customTitle = _this$props.customTitle,
          onMouseOut = _this$props.onMouseOut,
          onMouseOver = _this$props.onMouseOver,
          titleable = _this$props.titleable,
          CheckItemIconComponent = _this$props.CheckItemIconComponent,
          _this$props$Selection = _this$props.SelectionItemDataComponentProps,
          SelectionItemDataComponentProps = _this$props$Selection === void 0 ? {} : _this$props$Selection;
      var _data$mark = data.mark,
          mark = _data$mark === void 0 ? '' : _data$mark,
          _data$description = data.description,
          description = _data$description === void 0 ? '' : _data$description,
          dataTitle = data.title;

      var _getTheContentOfTheIt = (0, _index.getTheContentOfTheItemComponent)(_objectSpread({}, this.props, {
        disabled: data.disabled || false,
        labelDomClassName: 'in'
      })),
          className = _getTheContentOfTheIt.className,
          labelDom = _getTheContentOfTheIt.labelDom,
          label = _getTheContentOfTheIt.label,
          onClick = _getTheContentOfTheIt.onClick,
          checked = _getTheContentOfTheIt.checked;

      var title = '';

      if (!open) {
        return null;
      }

      if (titleable) {
        if (customTitle) {
          title = dataTitle;
        } else {
          if (typeof label === 'string' || typeof label === 'number') {
            title = label;
          }

          if (typeof mark === 'string' || typeof mark === 'number') {
            title = "".concat(title, " ").concat(mark);
          }

          if (typeof description === 'string' || typeof description === 'number') {
            title = "".concat(title, " ").concat(description);
          }
        }
      }

      var liProps = _objectSpread({}, (0, _index.getDataSet)(data));

      if (changeTriggerEvent) {
        liProps[changeTriggerEvent] = onClick;
      }

      var SelectionItemDataComponent = this.getItemDataComponent();
      return _react["default"].createElement("li", _extends({
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver
      }, liProps, {
        "data-index": this.props['data-index']
      }), _react["default"].createElement(SelectionItemDataComponent, _extends({
        title: title,
        label: label,
        description: description,
        mark: mark,
        checked: checked,
        checkbox: multiple || useCheckMark ? _react["default"].createElement(_checkmark_icon_component["default"], {
          checked: checked,
          IconComponent: CheckItemIconComponent
        }) : null,
        labelNode: _react["default"].createElement("p", null, _react["default"].createElement("span", {
          className: "tt"
        }, labelDom, mark ? _react["default"].createElement("i", {
          className: "tt-remarks"
        }, mark) : null), description ? _react["default"].createElement("span", {
          className: "tt-description"
        }, description) : null),
        data: data
      }, SelectionItemDataComponentProps)));
    }
  }]);

  return SelectionLabelsItemComponent;
}(_react["default"].PureComponent);

var _default = SelectionLabelsItemComponent;
exports["default"] = _default;